import { api } from './api'

export const deleteEprUin = (uinId: number | string) =>
  api.delete(`/business_accounts/epr_uins/${uinId}`)
